<template>
  <div class="simple-page u-w12of12 u-bg-white-off u-relative">

    <div class="u-row u-center u-marg-t-lg" v-if="$route.params.slug === 'donnees-personnelles' ">
      <app-button @click="$hub.emit('cookie:open')">
        Manager préférence cookies
      </app-button>
    </div>
     
    <strates v-if="loaded" :data="data.brightStrates" />

  </div>
</template>

<script>

import Strates from '@/components/strates/Strates'
import AppButton from '@/components/common/AppButton'

export default {
  metaInfo () {
    return {
      link: [
        { rel: 'canonical', href: 'https://brig.ht/' + this.$route.params.slug }
      ]
    }
  },
  components: {
    Strates,
    AppButton
  },

  computed: {
    data () {
      return this.$store.getters['data/page']
    },
    loaded () {
      return this.$store.getters['data/loaded']
    }
  },

  created () {
    this.onInit()
  },

  methods: {
    onInit () {
      this.$store.dispatch('data/page', this.$route.params.slug).catch(err => {
        this.$router.push(this.$local('Homepage'))
      })
    }
  },

  watch: {
    $route () {
      this.onInit()
    }
  }
}
</script>